<template>
  <div class="ml-flag-dropdown" ref="flagDropdown">
    <div
      class="ml-flag-toggle"
      @click="toggleDropdown"
    >
      <img
        class="flag-icon"
        :src="languageFlag || getLanguageFlag"
        alt="language"
      />
    </div>

    <div v-if="isOpen" class="ml-flag-menu">
      <LanguageDropdownOptions @language-changed="onLanguageChanged" />
    </div>
  </div>
</template>

<script>

import i18nService from '@/core/services/i18n.service.js';
import LanguageDropdownOptions from './LanguageDropdownOptions.vue'

export default {
  name: 'LanguageDropdown',
  components: { LanguageDropdownOptions },
  
  computed: {

    getLanguageFlag() {
      return this.onLanguageChanged();
    },
  },
  data() {
    return {
      isOpen: false,
      languageFlag: '',
      languages: i18nService.languages
    };
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside);
  },
  methods: {
    toggleDropdown() {
      this.isOpen = !this.isOpen;
    },
    handleClickOutside(event) {
      if (!this.$refs.flagDropdown.contains(event.target)) {
        this.isOpen = false;
      }
    },

    onLanguageChanged() {
      this.languageFlag = this.languages.find(val => {
        return val.lang === i18nService.getActiveLanguage();
      }).flag;
    },
  }
};
</script>

<style scoped>
.ml-flag-dropdown {
  position: relative;
  display: inline-block;
}

.ml-flag-toggle {
  cursor: pointer;
  border: 1px solid #3699ff;
  background: transparent;
  padding: 10px;
  border-radius: 4px;
  outline: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.flag-icon {
  height: 20px;
  width: 20px;
  border-radius: 4px;
}

.ml-flag-menu {
  position: absolute;
  right: 0;
  top: calc(100% + 4px);
  background: white;
  border: 1px solid #ddd;
  border-radius: 4px;
  min-width: 175px;
  z-index: 1000;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.05);
  padding: 10px;
}
</style>
